import React from "react";
import { FormDiv, Input } from "../RegisterForm/RegisterStyle";
import { states, countries } from "../../components/Commons/userUtil/util";

export const StepOne = ({ handleInput, values }) => {
  return (
    <div>
      <FormDiv>
        <Input
          type='text'
          placeholder='Firstname'
          name='first_name'
          value={values.first_name}
          onChange={handleInput}
        />
        {/* <Label>{}</Label> */}
      </FormDiv>
      <FormDiv>
        <Input
          type='text'
          placeholder='Lastname'
          name='last_name'
          value={values.last_name}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='text'
          placeholder='Stage Name'
          name='stage_name'
          value={values.stage_name}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='email'
          placeholder='Email Address'
          name='email'
          value={values.email}
          onChange={handleInput}
        />
      </FormDiv>
    </div>
  );
};
export const StepTwo = ({ handleInput, values }) => {
  return (
    <div>
      <FormDiv>
        <Input
          type='number'
          placeholder='Phone Number'
          name='phone_number'
          value={values.phone_number}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='password'
          placeholder='Password'
          name='password'
          value={values.password}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='password'
          placeholder='Confirm Password'
          name='confirm_password'
          value={values.confirm_password}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='text'
          placeholder='Bio'
          name='biography'
          value={values.biography}
          onChange={handleInput}
        />
      </FormDiv>
    </div>
  );
};

export const StepThree = ({
  handleInput,
  handleGender,
  handleState,
  handleCountry,
  handleFile,
  values,
}) => {
  return (
    <div>
      <FormDiv>
        <Input
          type='file'
          placeholder='Upload Profile Picture'
          name='profile_pic'
          onChange={handleFile}
        />
      </FormDiv>
      <FormDiv>
        <Input
          type='text'
          placeholder='Date Of Birth (1970-12-21)'
          name='date_of_birth'
          value={values.date_of_birth}
          onChange={handleInput}
        />
      </FormDiv>
      <FormDiv>
        <select className='select' onChange={handleGender}>
          <option value='male'>Male</option>
          <option value='female'>Female</option>
        </select>
      </FormDiv>
      <FormDiv>
        <select className='select' onChange={handleState}>
          {states.map((state) => (
            <option value={state.toLowerCase()} key={state}>
              {state}
            </option>
          ))}
        </select>
      </FormDiv>
      <FormDiv>
        <select className='select' onChange={handleCountry}>
          {countries.sort().map((country) => (
            <option value={country.toLowerCase()} key={country}>
              {country}
            </option>
          ))}
        </select>
      </FormDiv>
    </div>
  );
};
